import { useState } from "react";
import { useReadMemory } from "./useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";

export const useAuth = () => {
  const dataFromMemory = useReadMemory(MemoryType.USER);
  const tokenFromMemory = useReadMemory(MemoryType.TOKEN)
  const expiry = tokenFromMemory ? (JSON.parse(atob(tokenFromMemory?.split('.')[1]))).exp : null;
  const isExpired = expiry ? (Math.floor((new Date()).getTime() / 1000)) >= expiry : false; 

  const [isAuthenticated] = useState(() => {
    if (dataFromMemory && Object.keys(dataFromMemory)?.length > 0 && tokenFromMemory && !isExpired) return true;
    return false;
  });
  return isAuthenticated;
};
